import { render, staticRenderFns } from "./LoginAuto.vue?vue&type=template&id=72565012&scoped=true&"
import script from "./LoginAuto.vue?vue&type=script&lang=js&"
export * from "./LoginAuto.vue?vue&type=script&lang=js&"
import style0 from "./LoginAuto.vue?vue&type=style&index=0&id=72565012&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72565012",
  null
  
)

export default component.exports